export default {
  siteName: '亚洲在线',
  siteDescription: '亚洲最全在线服务平台，汇聚亚洲各地优质资源与内容',
  nav: {
    home: '首页',
    categories: '分类浏览',
    about: '关于我们',
    contact: '联系我们',
  },
  footer: {
    copyright: '© 2026 亚洲在线 版权所有',
    terms: '服务条款',
    privacy: '隐私政策',
    disclaimer: '免责声明',
  },
  home: {
    heroTitle: '亚洲在线',
    heroSubtitle: '亚洲最全在线服务平台',
    heroDescription: '汇聚亚洲各地优质资源与内容，提供便捷、安全、高效的在线体验。无论您身处亚洲何地，亚洲在线都能满足您的多元需求，立即探索亚洲在线的无限可能。',
    heroCTA: '立即探索',
    learnMore: '了解更多',
    servicesTitle: '我们的服务',
    servicesSubtitle: '一站式满足您的多元需求',
    hotArticles: '热门推荐',
    hotArticlesSubtitle: '精选亚洲各地优质内容',
    viewAll: '查看全部',
    faqTitle: '常见问题',
    faqSubtitle: '关于亚洲在线的常见疑问解答',
    ctaTitle: '准备好开启亚洲之旅了吗？',
    ctaSubtitle: '加入亚洲在线，探索无限可能',
    ctaButton: '立即加入',
  },
  category: {
    title: '内容分类',
    allCategories: '全部分类',
  },
  article: {
    backToList: '返回列表',
    readMore: '阅读更多',
    publishedOn: '发布于',
    authorLabel: '作者',
    views: '次阅读',
  },
  about: {
    title: '关于我们',
    brandIntro: '品牌介绍',
    reputation: '信誉与资质',
    contactUs: '联系我们',
  },
};